import { createContext } from 'react';
import EditCloverPointConfigContext from 'types/contexts/EditCloverPointConfigContext';

export default createContext({} as EditCloverPointConfigContext);
